import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, TextInput } from '@mantine/core';
import { useState } from 'react';

import { useSetManagerPassword } from '../api/setManagerPassword';
import { managerTypes } from '../types';

import { Departments } from '@/types';

type Params = {
  manager: managerTypes.Manager;
  department: Departments;
};

export const SetPasswordModal = NiceModal.create(({ manager }: Params) => {
  const modal = useModal();

  const [password, setPassword] = useState('');

  const { mutate, isLoading } = useSetManagerPassword({
    config: { onSuccess: modal.remove },
  });

  const submit = () => {
    if (!password) {
      return;
    }
    mutate({ managerId: manager._id, password });
  };

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title={`${manager.username} password`}
    >
      <TextInput
        type="password"
        placeholder="Password"
        value={password}
        onChange={(event) => setPassword(event.currentTarget.value)}
        my="xl"
      />
      <Group justify="right">
        <Button loading={isLoading} onClick={submit}>
          Save
        </Button>
      </Group>
    </Modal>
  );
});
